/**
 * CapabilityChecker checks if the selected template config matches the data content
 * of the user resume. If there are mismatches, it yields structural warnings or flags.
 */
export function validateCapabilities(template, resumeData) {
  const violations = [];

  if (!template || !template.capabilities) {
    return violations;
  }

  const { capabilities } = template;

  // 1. Profile Picture Check
  if (resumeData.personalInfo?.photoUrl && !capabilities.supportsPhoto) {
    violations.push({
      field: 'photoUrl',
      message: `The "${template.name}" template does not support profile photos. The photo will be hidden in exports.`,
      severity: 'warning'
    });
  }

  // 2. Icon Indicators Check
  if (capabilities.supportsIcons === false) {
    const hasIconsUsed = !!(resumeData.personalInfo?.linkedin || resumeData.personalInfo?.github || resumeData.personalInfo?.website);
    if (hasIconsUsed) {
      violations.push({
        field: 'socialIcons',
        message: `The "${template.name}" template does not display social media branding icons. Contact fields will render as plain text.`,
        severity: 'info'
      });
    }
  }

  // 3. Skill Level Ratings Check
  if (!capabilities.supportsRating) {
    const hasRatings = resumeData.skills?.some(skill => typeof skill.level === 'number' || typeof skill.rating === 'number');
    if (hasRatings) {
      violations.push({
        field: 'skills.rating',
        message: `The "${template.name}" template displays text-only skill listings. Visual proficiency bars or stars will be hidden.`,
        severity: 'info'
      });
    }
  }

  // 4. Accent Bar Check
  if (!capabilities.supportsAccentBar) {
    // If the template style config or styling settings request an accent bar, warn the user.
    if (template.styleOverrides?.['--layout-accent-bar-width']) {
      violations.push({
        field: 'accentBar',
        message: `This layout configuration does not support dynamic accent bars. Styling directives will be skipped.`,
        severity: 'info'
      });
    }
  }

  return violations;
}
